import { CurtainProductType } from '../../constants/productTypes';
import { ProductBuilderMachineState } from '../../types';

type CurtainStatesByProductType = {
  [key in CurtainProductType]: ProductBuilderMachineState[];
};

export const allCurtainStates: ProductBuilderMachineState[] = [
  'transparency',
  'colour',
  'pleatType',
  // 'pleatFinish',
  'measurements',
  'lining',
  'liningColour',
  'fitting',
  'configuration', // Name is stack
  // 'measureInsurance',
  // 'track',
  'trackColour',
  'wand_option',
  'wand_colour',
  // 'pullRod',
  // 'pullRodColour',
  'roomName',
  // 'shipping',
  'complete',
];

const curtainsStates = allCurtainStates.filter(state => {
  const curtainsExcludeList: ProductBuilderMachineState[] = [];
  return !curtainsExcludeList.includes(state);
});

export const luxurySheerStates = allCurtainStates.filter(state => {
  const luxurySheerExcludeList: ProductBuilderMachineState[] = [];
  return !luxurySheerExcludeList.includes(state);
});

export const curtainStatesByProductType: CurtainStatesByProductType = {
  Curtain: curtainsStates,
  'Sheer Curtain': luxurySheerStates,
};
